const getters = {
  items: state => state.items,
  page: state => state.page,
  pageCount: state => state.pageCount,
  total: state => state.total,
  hasMorePages: state => state.hasMorePages,
  isLoaded: state => state.isLoaded,
  isChanged: state => state.isChanged,
  validationError: state => state.validationError,
};

export default getters;


// WEBPACK FOOTER //
// ./src/modules/user/vuex/getters.js